import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideScrollbarOptions } from 'ngx-scrollbar';
import { API_BASE_URL } from '@doctor-scheduling/web/data-access';
import { appRoutes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { environment } from '../environments/environment';

/** Angular bootstrap providers for routing, HTTP, and animations. */
export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(appRoutes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimationsAsync(),
    provideScrollbarOptions({
      appearance: 'compact',
      visibility: 'hover',
      orientation: 'auto',
      trackScrollDuration: 50,
      scrollHideDelay: 500,
      scrollThrottleTime: 100,
    }),
    { provide: API_BASE_URL, useValue: environment.apiUrl },
  ],
};
